/**
 * @packageDocumentation
 * @module      SystemTesterConsts.ts
 * @description Encapsulates the SystemTester constansts used in the UI logic.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
class SystemTesterConsts {
}
SystemTesterConsts.startTests = "Start System Tester ";
SystemTesterConsts.driveModuleVers1 = "Drive Module 1 PCBA is at FW version ";
SystemTesterConsts.driveModuleVers2 = "Drive Module 2 PCBA is at FW version ";
SystemTesterConsts.driveModuleVers3 = "Drive Module 3 PCBA is at FW version ";
SystemTesterConsts.driveModuleVers4 = "Drive Module 4 PCBA is at FW version ";
SystemTesterConsts.armP1P2Vers = "Arm P12 PCBA is at FW version ";
SystemTesterConsts.armP34P5Vers = "Arm P345 PCBA is at FW version ";
SystemTesterConsts.frameboardVers = "Frame PCBA is at FW version ";
SystemTesterConsts.psrcVers = "Patient Side Robotic Controller is at version ";
SystemTesterConsts.psicVers = "Patient Side Imaging Computer is at version ";
SystemTesterConsts.psuiVers = "Patient Side User Interface is at version ";
SystemTesterConsts.psscVers = "Patient Side System Controller is at version ";
SystemTesterConsts.emcSoftwareVers = "The model is at version ";
SystemTesterConsts.emcUiToolVers = "The EMC User Interface is at version ";
SystemTesterConsts.systemTesterUIToolVers = "The System Tester User Interface is at version ";
SystemTesterConsts.csrcVers = "Control Side Robotic Controller is at version ";
SystemTesterConsts.csicVers = "Control Side Imaging Computer is at version ";
SystemTesterConsts.csuiVers = "Control Side User Interface is at version ";
SystemTesterConsts.csscVers = "Control Side System Controller is at version ";
SystemTesterConsts.pimVers = "PIM is at FW version ";
SystemTesterConsts.drive1CasetteOpen = "Module 1 Cassette Opened ";
SystemTesterConsts.drive1CasetteClosed = "Module 1 Cassette Closed ";
SystemTesterConsts.drive1CasetteUnlocked = "Module 1 Cassette Unlocked ";
SystemTesterConsts.drive1CasetteLocked = "Module 1 Cassette Locked ";
SystemTesterConsts.drive1CasetteTubeUnattched = "Module 1 Cassette Tube Unattached ";
SystemTesterConsts.drive1CasetteTubeAttached = "Module 1 Cassette Tube Attached ";
SystemTesterConsts.drive2CasetteOpen = "Module 2 Cassette Opened ";
SystemTesterConsts.drive2CasetteClosed = "Module 2 Cassette Closed ";
SystemTesterConsts.drive2CasetteUnlocked = "Module 2 Cassette Unlocked ";
SystemTesterConsts.drive2CasetteLocked = "Module 2 Cassette Locked ";
SystemTesterConsts.drive2CasetteTubeUnattached = "Module 2 Cassette Tube Unattached ";
SystemTesterConsts.drive2CasetteTubeAttached = "Module 2 Cassette Tube Attached ";
SystemTesterConsts.drive3CasetteOpen = "Module 3 Cassette Opened ";
SystemTesterConsts.drive3CasetteClosed = "Module 3 Cassette Closed ";
SystemTesterConsts.drive3CasetteUnlocked = "Module 3 Cassette Unlocked ";
SystemTesterConsts.drive3CasetteTubeUnattached = "Module 3 Cassette Tube Unattached ";
SystemTesterConsts.drive3CasetteTubeAttached = "Module 3 Cassette Tube Attached ";
SystemTesterConsts.drive4CasetteOpen = "Module 4 Cassette Opened ";
SystemTesterConsts.drive4CasetteClosed = "Module 4 Cassette Closed ";
SystemTesterConsts.drive4CasetteUnlocked = "Module 4 Cassette Unlocked ";
SystemTesterConsts.drive4CasetteLocked = "Module 4 Cassette Locked ";
SystemTesterConsts.drive4CasetteTubeUnattached = "Module 4 Cassette Tube Unattached ";
SystemTesterConsts.drive4CasetteTubeAttached = "Module 4 Cassette Tube Attached ";
SystemTesterConsts.frameProximalDetectDetached = "Cassette Proximal Anchor Detached ";
SystemTesterConsts.frameProximalDetectAttached = "Cassette Proximal Anchor Attached ";
SystemTesterConsts.frameDistalDetectDetached = "Cassette Distal Anchor Detached ";
SystemTesterConsts.frameDistalDetectAttached = "Cassette Distal Anchor Attached ";
SystemTesterConsts.passSelection = "User selected “Pass” ";
SystemTesterConsts.failSelection = "User selected “Fail” ";
SystemTesterConsts.endSelection = "User selected “End” ";
SystemTesterConsts.startTest = "Started test “Drive Lock/Unlock” ";
SystemTesterConsts.armUnlockButtonReleased = "Drive's Arm Unlock Button Released ";
SystemTesterConsts.armUnlockButtonPressed = "Drive's Arm Unlock Button Pressed ";
SystemTesterConsts.p1NoFaults = "P1 Joint has no detected faults ";
SystemTesterConsts.p1MotorAmpFault = "P1 Joint Motor Amplifier Fault ";
SystemTesterConsts.p1JointSensorFault = "P1 Joint Hall Sensor Fault ";
SystemTesterConsts.p1JointMotorEncoderFault = "P1 Joint Motor Encoder Fault ";
SystemTesterConsts.p1JointPCBAOpenFault = "P1 Joint PCBA Motor Controller Phase Open Fault ";
SystemTesterConsts.p1JointPCBAShortFault = "P1 Joint PCBA Motor Controller Phase Short Fault ";
SystemTesterConsts.p1DriveFault = "P1 Drive Train Fault ";
SystemTesterConsts.p1DriveInsufficientFault = "P1 PCBA Motor Voltage Insufficient Fault ";
SystemTesterConsts.p1EPWMFault = "P1 ePWM Fault ";
SystemTesterConsts.p1ADCREFFault = "P1 ADC_REF Fault ";
SystemTesterConsts.p1ShutdownFault = "P1 Shutdown Fault ";
SystemTesterConsts.p1UnwantedFault = "P1 Joint has an unspecified fault ";
SystemTesterConsts.p2NoFaults = "P2 Joint has no detected faults ";
SystemTesterConsts.p2MotorAmpFault = "P2 Joint Motor Amplifier Fault ";
SystemTesterConsts.p2JointSensorFault = "P2 Joint Hall Sensor Fault ";
SystemTesterConsts.p2JointMotorEncoderFault = "P2 Joint Motor Encoder Fault ";
SystemTesterConsts.p2JointPCBAOpenFault = "P2 Joint PCBA Motor Controller Phase Open Fault ";
SystemTesterConsts.p2JointPCBAShortFault = "P2 Joint PCBA Motor Controller Phase Short Fault ";
SystemTesterConsts.p2DriveTrainFault = "P2 Drive Train Fault ";
SystemTesterConsts.cassetteOpen = "Cassette Cover Open ";
SystemTesterConsts.cassetteClosed = "Cassette Cover Close ";
SystemTesterConsts.cassetteLocked = "Cassette Locked ";
SystemTesterConsts.cassetteUnlocked = "Cassette Unlocked ";
SystemTesterConsts.cassetteTubeAttached = "Cassette Tube Attached ";
SystemTesterConsts.cassetteTubeDetached = "Cassette Tube Detached ";
SystemTesterConsts.estopActive = "ESTOP is active ";
SystemTesterConsts.estopInactive = "ESTOP is inactive ";
SystemTesterConsts.startSystemTests = "System Tests started ";
SystemTesterConsts.stopSystemTests = "System Tests stopped ";
SystemTesterConsts.systemTestsDuration = "The duration of the System Tests was ";
SystemTesterConsts.module1 = "Module 1 ";
SystemTesterConsts.module2 = "Module 2 ";
SystemTesterConsts.module3 = "Module 3 ";
SystemTesterConsts.module4 = "Module 4 ";
SystemTesterConsts.p1Fault = "P1 ";
SystemTesterConsts.p2Fault = "P2 ";
SystemTesterConsts.p34Fault = "P34 (Gas Spring) ";
SystemTesterConsts.p5Fault = "P5 ";
SystemTesterConsts.mins = "mins ";
SystemTesterConsts.unspecifiedFaults = "has an unspecified fault";
SystemTesterConsts.truncatedLogMessage = "WARNING: Log truncated to last 500MB.\n\n";
SystemTesterConsts.parentTestPassed = " passed";
SystemTesterConsts.parentTestFailed = " failed";
SystemTesterConsts.parentTestSkipped = " skipped";
SystemTesterConsts.subTestStarted = " started";
export default SystemTesterConsts;
//# sourceMappingURL=SystemTesterConsts.js.map